import { create } from 'zustand';

export type BizyPageType = 'home' | '1on1' | 'goals' | 'rewards' | 'feed' | 'team';

export interface BizyPageContext {
	pageName: string;
	pageType: BizyPageType;
	pageData?: Record<string, string>;
}

interface BizyPageContextStore {
	context: BizyPageContext;
	setContext: (context: BizyPageContext) => void;
}

const defaultContext: BizyPageContext = {
	pageName: 'Home',
	pageType: 'home',
};

export const useBizyPageContextStore = create<BizyPageContextStore>((set) => ({
	context: defaultContext,
	setContext: (context) => set({ context }),
}));
